var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChart2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.9999C1 12.2404 1.61562 11.6249 2.375 11.6249H5.12501C5.88439 11.6249 6.50001 12.2404 6.50001 12.9999V19.8749C6.50001 20.6343 5.88439 21.2499 5.12501 21.2499H2.375C1.61562 21.2499 1 20.6343 1 19.8749V12.9999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2501 7.49976C9.2501 6.74037 9.86572 6.12476 10.6251 6.12476H13.3751C14.1345 6.12476 14.7501 6.74037 14.7501 7.49976V19.8748C14.7501 20.6342 14.1345 21.2498 13.3751 21.2498H10.6251C9.86572 21.2498 9.2501 20.6342 9.2501 19.8748V7.49976Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.5 3.375C17.5 2.61562 18.1156 2 18.875 2H21.625C22.3844 2 23 2.61562 23 3.375V19.875C23 20.6344 22.3844 21.25 21.625 21.25H18.875C18.1156 21.25 17.5 20.6344 17.5 19.875V3.375Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChart2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Chart2.958b8fcf622bdb8c3e40b2f08f600cbe.svg";